import { createSlice } from "@reduxjs/toolkit";
import { getFolderInFolderThunk, getFolderRootThunk, setFolderHistory } from "./thunk";

export const initialState = {
  folderRootPath: null,
  folders: null,
  folderHistory: [],
  selectedItems: [],
  selectedTableItem: null
}

const folderSlice = createSlice({
  name: "Folder",
  initialState,
  reducers: {
    setFolderRootPath(state, action) {
      state.folderRootPath = action.payload;
    },
    setFolders(state, action) {
      state.folders = action.payload;
    },
    addSelectedItem(state, action) {
      state.selectedItems.push(action.payload);
    },
    removeSelectedItem(state, action) {
      state.selectedItems = state.selectedItems.filter(item => item._id !== action.payload);
    },
    resetSelectedItems(state, action) {
      state.selectedItems = [];
    },
    setSelectedItem(state, action) {
      state.selectedTableItem = action.payload;
    },
    resetFolderState(state) {
      state.folderRootPath = null;
      state.folders = null;
      state.folderHistory = [];
      state.selectedItems = [];
      state.selectedTableItem = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getFolderRootThunk.fulfilled, (state, action) => {
      state.folders = action.payload;
    }),
      builder.addCase(getFolderInFolderThunk.fulfilled, (state, action) => {
        state.folders = action.payload;
      }),
      builder.addCase(setFolderHistory.fulfilled, (state, action) => {
        state.folderHistory = action.payload;
      })
  }
});

export const {
  setFolderRootPath,
  setFolders,
  addSelectedItem,
  removeSelectedItem,
  resetSelectedItems,
  setSelectedItem,
  resetFolderState
} = folderSlice.actions;

export default folderSlice.reducer;